import React from 'react';
import { ReactComponent as HeartOffGrayIcon } from '@assets/images/app/heart-gray.svg';
import { ReactComponent as HeartOnIcon } from '@assets/images/app/heart-pink.svg';
import { ReactComponent as HeartOffWhiteIcon } from '@assets/images/app/heart-white.svg';

interface FavoriteButtonProps {
  productId?: string;
  saleType?: string;
  style?: any;
  theme?: string;
}

export const FavoriteButton: React.FC<FavoriteButtonProps> = (props) => {
  const isFavorite = true;

  return (
    <button
      className="link-button"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '32px',
        height: '32px',
        ...props.style,
      }}>
      {isFavorite ? <HeartOnIcon /> : props.theme === 'white' ? <HeartOffWhiteIcon /> : <HeartOffGrayIcon />}
    </button>
  );
};

export default FavoriteButton;
